
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { AppLayout } from "@/components/layout/AppLayout";
import LoginPage from "@/pages/auth/Login";
import NotFound from "@/pages/NotFound";
import Index from "@/pages/Index";
import RegisterPage from "@/pages/auth/Register";
import Dashboard from "@/pages/dashboard/Dashboard";
import AcceptInvite from "@/pages/auth/AcceptInvite";
import Clients from "@/pages/clients/Clients";
import ClientDetail from "@/pages/clients/ClientDetail";
import Workflow from "@/pages/workflow/Workflow";
import Finances from "@/pages/finances/Finances";
import Calendar from "@/pages/calendar/Calendar";
import Approvals from "@/pages/approvals/Approvals";
import Goals from "@/pages/goals/Goals";
import Settings from "@/pages/settings/Settings";
import ApprovalView from "@/pages/external/ApprovalView";
import ApprovalPage from "@/pages/approvals/ApprovalPage";
import { BrandingProvider } from "@/components/BrandingProvider";
import ArchivedApprovals from "@/pages/approvals/ArchivedApprovals";
import ResetPassword from "@/pages/auth/ResetPassword";
import UpdatePassword from "@/pages/auth/UpdatePassword";
import Collaborators from "@/pages/collaborators/Collaborators";
import AcceptCollaboratorInvite from "@/pages/collaborators/AcceptInvite";
import MindMapPage from "@/pages/mindmap/MindMapPage";
import FacebookCallback from "@/pages/auth/FacebookCallback";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfService from "@/pages/legal/TermsOfService";
import InstagramConfig from "@/pages/settings/InstagramConfig";
import InstagramWebhook from "@/pages/api/InstagramWebhook";
import ProcessesPage from "@/pages/processes/ProcessesPage";
import ProcessEditorPage from "@/pages/processes/ProcessEditorPage";
import { LinkShortPage } from "@/pages/link-short/LinkShortPage";
import { EditLinkPage } from "@/pages/link-short/EditLinkPage";
import { PublicLinkPage } from "@/pages/link-short/PublicLinkPage";

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="theme">
      <BrandingProvider>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/accept-collaborator-invite" element={<AcceptCollaboratorInvite />} />
          <Route path="/collaborators/accept-invite" element={<AcceptCollaboratorInvite />} />
          <Route path="/approve/:slug" element={<ApprovalView />} />
          <Route path="/auth/facebook/callback" element={<FacebookCallback />} />
          <Route path="/api/webhook/instagram" element={<InstagramWebhook />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
          {/* Public link routes - New format as requested */}
          <Route path="/board/client/:slug" element={<PublicLinkPage />} />
          <Route path="/public/board/:slug" element={<PublicLinkPage />} />
          <Route path="/l/:slug" element={<PublicLinkPage />} />
          
          <Route path="/" element={<AppLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="workflow" element={<Workflow />} />
            <Route path="mindmap/:boardId" element={<MindMapPage />} />
            <Route path="finances" element={<Finances />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="approvals/:id" element={<ApprovalPage />} />
            <Route path="goals" element={<Goals />} />
            <Route path="collaborators" element={<Collaborators />} />
            <Route path="arquivados" element={<ArchivedApprovals />} />
            <Route path="processes" element={<ProcessesPage />} />
            <Route path="processes/:id" element={<ProcessEditorPage />} />
            <Route path="link-short" element={<LinkShortPage />} />
            <Route path="link-short/:id" element={<EditLinkPage />} />
            <Route path="settings" element={<Settings />} />
            <Route path="instagram-config" element={<InstagramConfig />} />
          </Route>

          {/* Catch-all dynamic route for simple slugs - must be last */}
          <Route path="/:slug" element={<PublicLinkPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrandingProvider>
    </ThemeProvider>
  );
}

export default App;
